<template>
  <div class="overflow-hidden modal">
    <!-- overlay -->
    <transition
      name="overlay"
      enter-active-class="animated fadeIn"
      leave-active-class="animated fadeOut"
    >

      <portal to="overlay">
        <div class="fixed pin z-20" v-if="isModalVisible">
          <div
            @click="hideModal()"
            class="absolute pin bg-black opacity-25"></div>
        </div>
      </portal>
    </transition>
    <!-- end overlay -->

    <transition
      name="paths"
      leave-active-class="animated fadeOut faster"
      enter-active-class="animated fadeIn faster"
    >

      <portal to="modal">
        <div v-if="isModalVisible"
          class="fixed pin flex modal overflow-auto z-40">
          <div
            class="relative bg-gray-lightest w-full flex-col flex overflow-auto p-8">

            <div class="container mx-auto">
              <div class="lg:w-1/2 m-auto">

                <div @click="goBack()"
                  class="text-xs cursor-pointer underline text-full-blue"
                >Back</div>

                <div class="flex justify-between items-center pb-6">
                  <h2 class="text-2xl py-4 font-bold">Add Connection <a target="_blank" href="https://www.tatatap.com/connections" class="text-xs font-normal">What is this?</a></h2>
                </div>

                <div class="container">
                  <div class="pb-8">
                    <form @submit.prevent="addConnection">
                      <div class="mb-4"> <!-- TODO: this could be a field type for forms -->
                        <label class="block mb-2">Connection Type</label>
                        <select v-model="type" class="block bg-white px-1 py-2">
                          <option value="TELEGRAM">Telegram</option>
                          <option value="SIGNAL" v-if="member.flags.connections">Signal (Beta)</option>
                        </select>
                      </div>
                      
                      <div v-if="type === 'SIGNAL'">
                        <p class="mb-4 leading-normal bg-yellow p-4 rounded"><strong>Please note: Tap does not store your Signal Messages in an encrypted state.</strong> When we receive a message from your Signal number it will be saved unencrypted, the same as any other note. Please refer to the <a href="https://www.tatatap.com/signal">Signal connection guide</a> for more details</p>

                        <div class="mb-4">
                          <label class="block mb-2">Your Signal Number</label>
                          <p class="text-xs mb-2">Include the number country code.</p>
                          <input
                            @input="formatNumber( $event.target.value)"
                            :value="displayTarget"
                            class="block appearance-none border border-white bg-white text-grey-darker py-1 px-2 rounded-l focus:outline-none focus:bg-white focus:border-grey" />
                        </div>
                      </div>
                      <div v-if="type === 'TELEGRAM'">
                        <p class="text-base mb-2 leading-normal">
                          To connect to the Tap Telegram bot, you need to initiate a conversation with Tap from your Telegram account.
                        </p>
                        <p class="text-base mb-2 leading-normal">
                          <a href="https://t.me/tatatap_com_bot">@tatatap_com_bot</a> is the Tap bot. Follow that link and send the '/start' command. We'll reply with instructions to complete the connection.
</p>

                      </div>
                      <p v-if="error" class="mt-2 text-red text-sm">{{error}}</p>
                      <div class="flex justify-end items-center">
                        <div class="cursor-pointer mr-4" @click="hideModal()">
                          Cancel
                        </div>
                        <t-button
                          type="submit"
                          :disabled="isDisabled"
                        >Add Connection</t-button>
                      </div>
                      
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </portal>
    </transition>
    <connection-verification-modal
      v-if="connection"
      :connection="connection"
      @close="showConnectionVerificationModal = false"
      @complete="completeVerification"
      :isModalVisible="showConnectionVerificationModal" />
  </div>
</template>

<script>
 import {mapState} from 'vuex'
 import {AsYouType, parsePhoneNumberFromString} from 'libphonenumber-js'
 import api from '@/api'
 import ConnectionVerificationModal from '@/components/ConnectionVerificationModal'

 export default {
   name: 'add-connection-modal',

   props: {
     isModalVisible: {
       type: Boolean,
       default: true
     },
   },

   data () {
     return {
       target: '+',
       displayTarget: '',
       type: 'TELEGRAM',
       connection: null,
       error: '',
       showConnectionVerificationModal: false
     }
   },

   components: {
     ConnectionVerificationModal
   },

   computed: {
     ...mapState({member: state => state.member }),
     isDisabled() {
       return ['TELEGRAM'].indexOf(this.type) !== -1
     }
   },

   methods: {
     async addConnection () {
       const {res, err} = await api.addConnection(this.type, this.target)

       if (err) {
         this.error = err.response.data
         return
       }

       this.connection = res
       this.showConnectionVerificationModal = true
     },

     completeVerification (res) {
       this.hideModal()
       this.$emit('complete')
     },

     hideModal () {
       this.target = '+'
       this.displayTarget = ''
       this.connection = null
       this.error = ''
       this.showConnectionVerificationModal = false

       this.$emit('close');
     },

     goBack() {
       this.hideModal()
     },

     formatNumber (input) {
       const n = new AsYouType()

       if (/^\+/.test(input) === false) {
         input = '+' + input
       }

       this.displayTarget = n.input(input)

       if (n.getNumber()) {
         this.target = n.getNumber().number
       }
     }
   },
 }
</script>
